import React, {Component} from "react";
import {Row} from "reactstrap";

class InformationCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cardModal: false
        }
        this.onClick = this.onClick.bind(this);
    }

    onClick() {
        if (this.state.cardModal) {
            this.setState({cardModal: false});
        } else {
            this.setState({cardModal: true});
        }
    }

    render() {
        return (
            <div>
                <div>
                    <button
                        onClick={this.onClick} 
                        className="btn btn-dark btn-circle btn-circle-sm m-1">
                        <i className="fa fa-info"></i>
                    </button>
                </div>

                {this.state.cardModal &&

                    <div className="modal fade show" role="dialog" tabIndex="-1" style={{display: "block"}}>
                        <div className="modal-dialog modal-xl">
                                <div className="row1-container">
                                    <div className="infoBox red">
                                        <div onClick={() => this.onClick()} className="closeBtn"></div>

                                        <h2>{this.props.header}</h2>
                                        <p>Defter Beyan Sitemine (DBS) mükellefinizin faturasını aktarabilmek için izlenmesi
                                            gereken adımlar:</p>
                                        <p><h4>1. Portal üzeinden mükellefinizin muhasebecisi olarak görünmelisiniz.</h4></p>
                                        <div className="horizontalLine mt-2 mb-4"/>
                                        <p><h4>2. Firma profili sayfasında mükellefinizin DBS bilgilerini girmelisiniz.</h4></p>
                                        <p> Ayarlar >> Firma Profili >> Defter Beyan Bilgileri</p>
                                        <p><span>Burada mükellefinizin DBS sisteminden aldığınız VKN’sini yazmalısınız. (Vergi Kimlik nuamrası).</span></p>
                                        <div className="horizontalLine mt-2 mb-4"/>
                                        <p><h4>3. Portal Yönetimi altından mükellefinizin portalına geçiş
                                            yapmalısınız. Geçiş sonrasında Müşterinizin portalından belgeyi göndermek istediği
                                            hizmetin sayfasına giderek gönderim yapabilirsiniz.</h4></p>
                                        <p><span>Portal Yönetimi >> Müşteri İşlemleri >> Seçiniz >> Kullanıcı Portalına Git</span></p>
                                        <div className="horizontalLine mt-2 mb-4"/>
                                        <p><h4>4. Bu aşamadan sonra DBS kayıtları sadece Müşavirin / Muhasebecinin
                                            DBS giriş bilgileri ile yapılır. Mükellef bilgileri geçersizdir.</h4></p>
                                    </div>
                                </div>
                        </div>
                    </div>

                }
            </div>
        )
    }

}
export default InformationCard;